export const DataMutation_Shipping_SetShippingMethodsOnCart_QueryKey = {
  shippingSetShippingMethodsOnCart: (): string => {
    const queryKey = "data-mutation--shipping-set-shipping-methods-on-cart";
    return queryKey;
  },
};
